import React from "react";
import "./stats.css";

const statsData = [
  { id: "01", value: "6+", label: "Years of Experience" },
  { id: "02", value: "5+", label: "Countries" },
  { id: "03", value: "40+", label: "Completed Projects" },
  { id: "04", value: "25+", label: "Happy Customers" },
];

export default function Stats() {
  return (
    <div className="stats-container">
      {statsData.map((stat, index) => (
        <div className="stat-box" key={index}>
          <p className="stat-id">{stat.id}</p>
          <h2 className="stat-value">{stat.value}</h2>
          <p className="stat-label">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}